import { render, staticRenderFns } from "./ViewCandidateProfile.vue?vue&type=template&id=bb0bf3cc&scoped=true"
import script from "./ViewCandidateProfile.vue?vue&type=script&lang=ts"
export * from "./ViewCandidateProfile.vue?vue&type=script&lang=ts"
import style0 from "./ViewCandidateProfile.vue?vue&type=style&index=0&id=bb0bf3cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0bf3cc",
  null
  
)

export default component.exports